// extracted by mini-css-extract-plugin
export default {"breakpointxs":"0","product-list__list":"ProductList_product-list__list__UaT4V","product-list__list-item":"ProductList_product-list__list-item__0tyk7"};